import { useTranslation } from "react-i18next";

import { ReactComponent as GeoFlag } from "../../static/images/geo_flag.svg";
import { ReactComponent as EnglishFlag } from "../../static/images/english_flag.svg";
import { ReactComponent as SpainFlag } from "../../static/images/spain_flag.svg";
import { ReactComponent as ItalyFlag } from "../../static/images/italy_flag.svg";
import { ReactComponent as UkraineFlag } from "../../static/images/ukraine_flag.svg";
import { ReactComponent as GermanyFlag } from "../../static/images/germany_flag.svg";
import { ReactComponent as FranceFlag } from "../../static/images/france_flag.svg";
import { generateUniqueId } from "../../store/GlobalVarriables";

import "./style.scss";

const langKeys = {
  en: "ENG",
  ka: "GEO",
  ukr: "UKR",
  spa: "SPA",
  ita: "ITA",
  ger: "GER",
  fra: "FRA",
};

const languages = [
  { lang: "ka", flag: <GeoFlag />, show: true, id: generateUniqueId() },
  { lang: "en", flag: <EnglishFlag />, show: true, id: generateUniqueId() },
  { lang: "spa", flag: <SpainFlag />, show: true, id: generateUniqueId() },
  { lang: "ita", flag: <ItalyFlag />, show: true, id: generateUniqueId() },
  { lang: "ger", flag: <GermanyFlag />, show: true, id: generateUniqueId() },
  { lang: "fra", flag: <FranceFlag />, show: true, id: generateUniqueId() },
  { lang: "ukr", flag: <UkraineFlag />, show: true, id: generateUniqueId() },
];

export const langOptions = languages.map((option) => ({
  value: langKeys[option.lang],
  label: (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      {option.flag}
      <span>{langKeys[option.lang]}</span>
    </div>
  ),
}));

const LangSwitcher = ({}) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();

  const savedLanguage = localStorage.getItem("language") || "en";

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("language", lang);
  };

  const finalLangs = languages.filter(
    (item) => item.show && item.lang !== savedLanguage,
  );

  return (
    <div className="lang-switcher">
      <span>{t("choose_language")}</span>
      <div className="languages">
        {finalLangs.map((item) => {
          return (
            <button
              key={item.id}
              onClick={() => handleLanguageChange(item.lang)}
            >
              {item.flag}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default LangSwitcher;
